import { memo, useEffect } from 'react'
import { getTokenDecimals } from '../../utils/tokens'
import {
  useSelectedToken,
  useSelectFast,
  useWithdrawLayoutType,
} from '../../store/withdraw/hook'
import { useAtomValue } from 'jotai'
import { withdrawSelectNet } from './WithdrawMain'
import { useAppDispatch } from '../../store'
import { clearBrokerInfo } from '../../store/broker/reducer'
import { fetchBrokerInfoAction } from '../../store/broker/actions'
import { WithdrawLayoutType } from '../../store/withdraw/types'
import { isRejected } from '@reduxjs/toolkit'
import { updateSelectFast } from '../../store/withdraw/actions'

export const WithdrawBroker = memo(() => {
  const dispatch = useAppDispatch()
  const selectedToken = useSelectedToken()
  const selectedNetwork = useAtomValue(withdrawSelectNet)
  const selectedFast = useSelectFast()
  const layoutType = useWithdrawLayoutType()
  useEffect(() => {
    if (layoutType !== WithdrawLayoutType.Withdraw) return
    if (!selectedToken || !selectedNetwork || !selectedFast) {
      dispatch(clearBrokerInfo())
      return
    }

    const decimals = getTokenDecimals(
      selectedToken,
      selectedNetwork.layerTwoChainId,
    )

    dispatch(
      fetchBrokerInfoAction({
        chainId: selectedNetwork.layerOneChainId,
        tokenId: selectedToken.l2CurrencyId,
        decimals,
      }),
    ).then((r) => {
      // If the broker info is rejected,
      // we can't use the fast withdraw, so we should set the withdrawal type to standard.
      if (isRejected(r)) dispatch(updateSelectFast(false))
    })

    return () => {
      dispatch(clearBrokerInfo())
    }
  }, [dispatch, selectedToken, selectedNetwork, selectedFast, layoutType])
  return null
})
